import { ProductLevelCommissionOpts } from './product-level-commision-opts.model';
import { ProductLevelCommissionRecord } from './product-level-commision-record.model';
import { Stylist } from '../../stylist/stylist.model';

export class ProductLevelCommissionSetting extends ProductLevelCommissionRecord {
  // `declare` is load-bearing — see TimeSlot in
  // bookings/calendar/time-slot/time-slot.component.ts for why. Here, dropping
  // it made all three read undefined on every setting Product.parseProductData
  // builds, so ProductFormPage's `stylist.id === setting.stylistID` match never
  // landed: commission fields opened at 0 and saving wrote those zeroes back.
  declare public readonly stylistID: number;

  declare public readonly stylist: Stylist;

  declare public readonly commissionValue: number;

  constructor(params: ProductLevelCommissionOpts) {
    super(params);
  }

  public setCommissionValue(value: number): ProductLevelCommissionSetting {
    return this.set('commissionValue', value) as ProductLevelCommissionSetting;
  }
}
